import { $ } from "./imports";

const tagsCarousel = () => {

    function initializeTagsCarousel(selector, margin = 10){
        $(selector).each(function () {
            if( !$(this).hasClass('owl-carousel onlychevron') ){
                $(this).addClass('owl-carousel onlychevron').owlCarousel({
                    dots: false,
                    nav: true,
                    loop: false,
                    rewind: true,
                    autoWidth: true,
                    margin: margin,
                    onInitialized: checkNavigation,
                    onChanged: checkNavigation,
                    items: 1,
                    navText: [
                        '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                        '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
                    ],
                });
            }
        });
        
    }

    // Para mostrar botones de navegación, solo cuando hay items previos o siguientes
    function checkNavigation(event) {
        // Carrusel
        let owlCarousel = event.target;

        // Asegurémonos de que haya al menos un elemento en el carrusel
        if ($(owlCarousel).children().length === 0) {
            return;
        }

        // Contenedor overflow hidden
        // let owlStageOuter = $(event.target).find('.owl-stage-outer');
        const owlStageOuter = $(event.target).find('.owl-stage-outer')[0];
        if (!owlStageOuter) {
            return;
        }

        let itemCount = event.item.count;
        let currentIndex = event.item.index;
        // Navegacion prev/next
        let nextButton = $(event.target).find('.owl-next');
        let prevButton = $(event.target).find('.owl-prev');

        // Obtén el último elemento dentro del carrusel
        // const lastItem = owlCarousel.lastElementChild;
        const lastItem = $(owlCarousel).find(':last-child')[0];

        // Calcula las coordenadas del último elemento y del contenedor
        const lastItemRect = lastItem.getBoundingClientRect();
        const stageOuterRect = owlStageOuter.getBoundingClientRect();

        // Verifica si el último elemento está completamente visible
        const isLastItemVisible = (
            lastItemRect.left >= stageOuterRect.left &&
            lastItemRect.right <= stageOuterRect.right
        );

        if ((itemCount === 1 && isLastItemVisible) || (currentIndex === 0 && isLastItemVisible)) {
            // Si solo hay un elemento o estás en el primer elemento y el último es visible, oculta ambos botones.
            prevButton.hide();
            nextButton.hide();
        } else if (currentIndex === 0 && !isLastItemVisible) {
            // Primer ítem y el último no es visible, oculta el botón prev y muestra el botón next.
            prevButton.hide();
            nextButton.show();
        } else if (currentIndex > 0 && currentIndex < itemCount - 1 && !isLastItemVisible) {
            // Cuando no estás en el primer ni en el último elemento y el último no es visible, muestra ambos botones.
            prevButton.show();
            nextButton.show();
        } else if (currentIndex === itemCount - 1 && isLastItemVisible) {
            // Último ítem y completamente visible, oculta el botón next y muestra el botón prev.
            prevButton.show();
            nextButton.hide();
        } else {
            // En cualquier otro caso, muestra ambos botones.
            prevButton.show();
            nextButton.show();
        }

    }

    // Selectores de las secciones donde aplicar el carousel
    const sections = [
        // tags news-card
        { selector: '.blog-results__list .news-card__tags', margin: 10 },
        { selector: '.blog-list__list .news-card__wrapper-tags .item-list ul', margin: 10 },
        // Tags product-card
        { selector: 'body .product-card .product-card__tags', margin: 8 },
        // Categorias listado blog|noticias
        { selector: '.blog-filter__list form .form--inline .form-radios>.form-radios', margin: 17 }
    ];

    sections.forEach((section) => {
        if ($(section.selector).length > 0) {
            initializeTagsCarousel(section.selector, section.margin);
        }
    });
    
}


export default tagsCarousel;